import { render, staticRenderFns } from "./EnableNotification.vue?vue&type=template&id=1bf25fe4&scoped=true&"
import script from "./EnableNotification.vue?vue&type=script&lang=js&"
export * from "./EnableNotification.vue?vue&type=script&lang=js&"
import style0 from "./EnableNotification.vue?vue&type=style&index=0&id=1bf25fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf25fe4",
  null
  
)

export default component.exports